import { ClientInterestDto } from '../api'
export class ClientInterestV2 implements ClientInterestDto {
  oid?: string = undefined
  ctm?: number = undefined
  utm?: number = undefined
  clientOid: string = undefined
  insuranceHealthSeminar?: number = undefined
  investmentRetirementSeminar?: number = undefined
  familyDayActivity?: number = undefined
  policyOwnerFunction?: number = undefined
  newsletter?: number = undefined
  productBrochure?: number = undefined
  birthday?: number = undefined
  chineseNewYear?: number = undefined
  hariRaya?: number = undefined
  deepavali?: number = undefined
  christmas?: number = undefined
  gift?: number = undefined

  constructor (clientOid?: string) {
    this.clientOid = clientOid
  }
}
